export const SCALE_BY = 0.25
export const RANGE = {
  MAX: 1.75,
  MIN: 0.5,
}
